/**
 * Per-tab pagination for general downloads (same chrome as product downloads).
 * Uses a class + !important to hide rows (li[hidden] is often overridden by theme CSS).
 * Uses delegated clicks so buttons stay wired even if something else touches the DOM.
 */
(function () {
  var paginationStateByPanel = new WeakMap();

  function applyPageState(panel, state) {
    var start = (state.currentPage - 1) * state.perPage;
    state.items.forEach(function (li, i) {
      var hide = i < start || i >= start + state.perPage;
      li.classList.toggle('general-downloads__item--paginated-out', hide);
    });

    var wrapper = panel.querySelector('[data-general-downloads-pagination]');
    if (!wrapper) return;

    var info = wrapper.querySelector('.product-downloads__pagination-info');
    var prevBtn = wrapper.querySelector('[data-pagination-prev]');
    var nextBtn = wrapper.querySelector('[data-pagination-next]');

    if (info) {
      info.textContent = 'Page ' + state.currentPage + ' of ' + state.totalPages;
    }
    if (prevBtn) {
      prevBtn.disabled = state.currentPage <= 1;
    }
    if (nextBtn) {
      nextBtn.disabled = state.currentPage >= state.totalPages;
    }
  }

  /**
   * When row visibility changes, list height changes and the pagination bar jumps in the viewport.
   * Measure the bar before/after and scroll by the delta so the page feels stable.
   */
  function applyPageStateWithScrollStability(panel, state) {
    var wrapper = panel.querySelector('[data-general-downloads-pagination]');
    var anchorTop = wrapper ? wrapper.getBoundingClientRect().top : null;

    applyPageState(panel, state);

    if (anchorTop === null || !wrapper) return;

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        var newTop = wrapper.getBoundingClientRect().top;
        var delta = newTop - anchorTop;
        if (Math.abs(delta) > 0.5) {
          window.scrollBy(0, delta);
        }
      });
    });
  }

  function bindDelegatedClicks(root) {
    if (root.getAttribute('data-general-downloads-pagination-bound') === 'true') {
      return;
    }
    root.setAttribute('data-general-downloads-pagination-bound', 'true');

    root.addEventListener(
      'click',
      function (e) {
        var t = e.target;
        if (!t || !t.closest) return;

        var nextBtn = t.closest('[data-pagination-next]');
        var prevBtn = t.closest('[data-pagination-prev]');
        if (!nextBtn && !prevBtn) return;

        if (!root.contains(nextBtn || prevBtn)) return;

        var panel = (nextBtn || prevBtn).closest('.general-downloads__tab-panel');
        if (!panel || !root.contains(panel)) return;

        var state = paginationStateByPanel.get(panel);
        if (!state) return;

        e.preventDefault();
        e.stopPropagation();

        if (nextBtn && state.currentPage < state.totalPages) {
          state.currentPage++;
          applyPageStateWithScrollStability(panel, state);
        } else if (prevBtn && state.currentPage > 1) {
          state.currentPage--;
          applyPageStateWithScrollStability(panel, state);
        }
      },
      false
    );
  }

  function setupPanelPagination(panel, perPage) {
    var list = panel.querySelector('.general-downloads__list');
    if (!list) return;

    panel.querySelectorAll('[data-general-downloads-pagination]').forEach(function (el) {
      el.remove();
    });

    var allLis = [].slice.call(list.querySelectorAll(':scope > .general-downloads__item'));
    var items = allLis.filter(function (li) {
      return li.querySelector('a.general-downloads__link');
    });

    allLis.forEach(function (li) {
      li.classList.remove('general-downloads__item--paginated-out');
      li.hidden = false;
    });

    if (items.length === 0 || items.length <= perPage) {
      paginationStateByPanel.delete(panel);
      return;
    }

    var currentPage = 1;
    var totalPages = Math.ceil(items.length / perPage);

    var wrapper = document.createElement('div');
    wrapper.className = 'product-downloads__pagination';
    wrapper.setAttribute('data-general-downloads-pagination', '');

    var prevEl = document.createElement('button');
    prevEl.type = 'button';
    prevEl.className =
      'product-downloads__pagination-button product-downloads__pagination-button--prev';
    prevEl.setAttribute('data-pagination-prev', '');
    prevEl.textContent = 'Previous';

    var info = document.createElement('span');
    info.className = 'product-downloads__pagination-info';

    var nextEl = document.createElement('button');
    nextEl.type = 'button';
    nextEl.className =
      'product-downloads__pagination-button product-downloads__pagination-button--next';
    nextEl.setAttribute('data-pagination-next', '');
    nextEl.textContent = 'Next';

    wrapper.appendChild(prevEl);
    wrapper.appendChild(info);
    wrapper.appendChild(nextEl);
    list.after(wrapper);

    var state = {
      items: items,
      perPage: perPage,
      currentPage: currentPage,
      totalPages: totalPages,
    };
    paginationStateByPanel.set(panel, state);
    applyPageState(panel, state);
  }

  function initGeneralDownloadsListPagination(root) {
    if (!root || root.getAttribute('data-general-downloads-paginate') === 'false') return;

    var perPage = parseInt(root.getAttribute('data-items-per-page') || '10', 10);
    if (isNaN(perPage) || perPage < 1) perPage = 10;

    bindDelegatedClicks(root);

    root.querySelectorAll('.general-downloads__tab-panel').forEach(function (panel) {
      setupPanelPagination(panel, perPage);
    });
  }

  window.initGeneralDownloadsListPagination = initGeneralDownloadsListPagination;

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-general-downloads-paginate]').forEach(function (el) {
      initGeneralDownloadsListPagination(el);
    });
  });
})();
